export default __webpack_public_path__ + "static/media/shading-blue.ed2155fd.svg";